<template>
  <van-row id="details" class="flex-column">
    <!-- NavBar part -->
    <mynavbar></mynavbar>

    <!-- title part -->
    <van-skeleton class="mt-4rem title" :row="2" :loading="loading">
      <van-row class="mt-4rem title">
        {{articles.title}}
      </van-row>
    </van-skeleton>

    <!-- channel author -->
    <van-row type="flex" justify="space-between" style="margin-top: 1.5rem;">
      <van-col span="16">
        <van-skeleton class="channel" :row="2" :loading="loading">
          <van-row class="channel">
            <van-icon name="label-o" color="#333333"> {{channelName}} </van-icon>
            <van-icon name="manager-o" style="margin-left: 1rem;" color="#333333"> {{articles.author}} </van-icon>
          </van-row>
          <van-row class="time">
            <van-icon name="clock-o"> {{articles.createTime}} </van-icon>
          </van-row>
        </van-skeleton>
      </van-col>
      <van-col span="8" style="padding-right: 1rem;">
        <van-skeleton class="channel" style="float: right;" avatar avatar-shape="square" avatar-size="" :loading="loading">
          <van-button style="float: right; width: 3.5rem; height: 1.6rem; font-size: 0.7rem;" color="linear-gradient(to right, #ff6034, #ee0a24)" @click="showShare = true">
            分享
          </van-button>
          <van-share-sheet
            v-model="showShare"
            title="立即分享给好友"
            :options="options"
            @select="updateAppMessageShare"
          />
        </van-skeleton>
      </van-col>
    </van-row>

    <van-divider></van-divider>
    <!-- content part -->
    <van-skeleton class="content" :row="10" :loading="loading">
      <van-row class="content" v-html="articles.content"></van-row>
    </van-skeleton>

    <!-- footer part -->
    <myfooter2></myfooter2>

  </van-row>
</template>

<script>
import navbar from '@/view/navbar/navbar'
import footer2 from '@/view/footer/footer2'
// import footer from '@/view/footer/footer'

const axios = require('axios')

// import wxapi from '@/utils/wxapi.js'
import wx from 'weixin-js-sdk'

// import Clipboard from 'clipboard'

import { Toast } from 'vant';
import { Notify } from 'vant';
import { Dialog } from 'vant';

export default {
  name: 'details',
  components: {
    'mynavbar' : navbar,
    'myfooter2' : footer2
  },
  data () {
    return {
      artId: null,
      articles: {'title': '', 'createTime': '2020-12-22 8:30:10', 'content': ''},
      categoryUrl: '/article/category/',
      channelName: '',
      author: '',
      loading: true,
      showShare: false,
      options: [
        { name: '微信', icon: 'wechat', id: 'wechat' },
        { name: '朋友圈', icon: 'wechat-moments', id: 'wechat-moments' },
        { name: 'QQ', icon: 'qq', id: 'qq' },
        { name: '微博', icon: 'weibo', id: 'weibo' },
        { name: '复制链接', icon: 'link', id: 'link' }
      ],
      title: ''
    }
  },
  created () {
    const artId = this.$route.params.id
    this.artId = artId
    this.shareConfig()
  },
  mounted () {
    let that = this
    // 加载文章
    that.init()
  },
  methods: {
    // 加载文章
    init: function () {
      var that = this
      // 获取文章
      axios.get(that.global.apiUrl + '/web/article?id=' + that.artId)
        .then(function (response) {
          if (response.data.success && response.data.data != null) {
            // 获取文章内容
            that.articles = response.data.data
            // console.log(that.articles.content)
            var str = that.articles.content
            str = str.replace(/api\/file/g, that.global.apiUrl + '/file')
            that.articles.content = str
            that.title = that.articles.title

            // 获取栏目信息
            axios.get(that.global.apiUrl + '/web/channel?id=' + that.articles.idChannel)
              .then(function (response) {
                if (response.data.success > 0) {
                  // console.log(response.data);
                  that.channelName = response.data.data.name
                }
              }
            )

            // 隐藏骨架屏
            that.loading = false

    //         // 获取当前栏目
    //         axios.get(that.global.apiUrl + '/web/channel?id=' + that.articles.idChannel)
    //           .then(function (res) {
    //             if (res.data.success && res.data.data != null) {
    //               that.currChannel = res.data.data

    //               // 获取父类栏目
    //               axios.get(that.global.apiUrl + '/web/channel?id=' + that.currChannel.pid)
    //                 .then(function (e) {
    //                   if (e.data.success && e.data.data != null) {
    //                     that.parentChannel = e.data.data
    //                   }
    //                 })

    //               // 获取子类列表
    //               axios.get(that.global.apiUrl + '/web/channel/getListByPid?pid=' + that.currChannel.pid)
    //                 .then(function (result) {
    //                   if (result.data.success && result.data.data != null) {
    //                     that.childrens = result.data.data
    //                   }
    //                 })
    //             }
    //           })
          } else {
            that.$router.push({ name: 'page404'})
          }
        })
    },

    shareConfig() {
      let currUrl = encodeURIComponent(window.location.href.split("#")[0])
      // let currUrl = encodeURIComponent("https://m.etjkxh.com/article/details/230".split("#")[0])
      let timestamps = Date.now()
      // let nonceStr = Math.round(Math.random() * 1000000)
      // 获取access_token 和 jsapi_ticket
      // axios.get(that.global.apiUrl + '/web/getWXConfig?requestUrl='+currUrl+'&title='+that.title)
      axios.get('https://m.etjkxh.com/wxconfig/index.php?currUrl='+currUrl+'&timestamp='+timestamps)
        .then(function (response) {
          // console.log(response);
          let desc = "微信关注“石家庄电子信息学校”，了解更多动态！"
          let signature = response.data.signPackage.signature
          let appId = response.data.signPackage.appId
          let timestamp = response.data.signPackage.timestamp
          let nonceStr = response.data.signPackage.nonceStr
          let url = response.data.signPackage.url
          wx.config({
              debug: false,
              appId: appId,
              timestamp: timestamp,
              nonceStr: nonceStr,
              signature: signature,
              jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'onMenuShareWeibo',
                'onMenuShareAppMessage',
              ]
          })

        }
      )
    },

    updateAppMessageShare() {
      let that = this
      wx.ready(function(){
        let desc = "微信关注“石家庄电子信息学校”，了解更多动态！"
        let currUrl = encodeURIComponent(window.location.href.split("#")[0])
        // let currUrl = encodeURIComponent("https://m.etjkxh.com/article/details/230".split("#")[0])
        wx.updateAppMessageShareData({
          title: that.title, // 分享标题
          desc: desc, // 分享描述
          link: currUrl, // 分享链接
          imgUrl: 'https://www.sjzeis.com/static/img/logo/logo-2.png', // 分享图标
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function () {
              // 用户确认分享后执行的回调函数
              console.log('分享成功');
              // Notify({ type: 'success', message: '分享成功' });
          },
          cancel: function () {
              // 用户取消分享后执行的回调函数
              console.log('分享取消');
              // Notify({ type: 'warning', message: '分享取消' });
          },
          fail: function (res) {
            console.log('分享失败'+res);
          }
        });
      })
    },

    // 分享
    onSelect(option) {
      var that = this
      var id = option.id
      if(id == 'wechat' || id == 'wechat-moments' || id == 'qq' || id == 'weibo') {
        // let appId = 'wx5bd9797f4d2a2e8c'
        // let appSecret = '0567e2f082eb892023dcaddd680641e1'
        let currUrl = encodeURIComponent(window.location.href.split("#")[0])
        // let currUrl = encodeURIComponent("https://m.etjkxh.com/article/details/230".split("#")[0])
        let timestamps = Date.now()
        // let nonceStr = Math.round(Math.random() * 1000000)
        // 获取access_token 和 jsapi_ticket
        // axios.get(that.global.apiUrl + '/web/getWXConfig?requestUrl='+currUrl+'&title='+that.title)
        axios.get('https://m.etjkxh.com/wxconfig/index.php?currUrl='+currUrl+'&timestamp='+timestamps)
          .then(function (response) {
            // console.log(response);
            let desc = "微信关注“石家庄电子信息学校”，了解更多动态！"
            let signature = response.data.signPackage.signature
            let appId = response.data.signPackage.appId
            let timestamp = response.data.signPackage.timestamp
            let nonceStr = response.data.signPackage.nonceStr
            let url = response.data.signPackage.url
            wx.config({
                debug: true,
                appId: appId,
                timestamp: timestamp,
                nonceStr: nonceStr,
                signature: signature,
                jsApiList: [
                // 所有要调用的 API 都要加到这个列表中
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'onMenuShareWeibo',
                'onMenuShareAppMessage',
              ]
            })

            // wx.ready会在wx.config正确执行后自动执行,因为用户自定义触发,所以不用写ready
            wx.ready(function(){
              if(id == 'wechat') {
                console.log("分享微信");
                // wx.onMenuShareAppMessage({
                //   title: that.title, // 分享标题
                //   desc: desc, // 分享描述
                //   link: currUrl, // 分享链接
                //   imgUrl: 'https://m.etjkxh.com/wxconfig/logo-share.png', // 分享图标
                //   type: '', // 分享类型,music、video或link，不填默认为link
                //   dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                //   success: function () {
                //       // 用户确认分享后执行的回调函数
                //       console.log('分享成功');
                //       // Notify({ type: 'success', message: '分享成功' });
                //   },
                //   cancel: function () {
                //       // 用户取消分享后执行的回调函数
                //       console.log('分享取消');
                //       // Notify({ type: 'warning', message: '分享取消' });
                //   },
                //   fail: function (res) {
                //     console.log('分享失败'+res);
                //   }
                // })
                wx.updateAppMessageShareData({
                  title: that.title, // 分享标题
                  desc: desc, // 分享描述
                  link: currUrl, // 分享链接
                  imgUrl: 'https://www.sjzeis.com/static/img/logo/logo-2.png', // 分享图标
                  type: '', // 分享类型,music、video或link，不填默认为link
                  dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                  success: function () {
                      // 用户确认分享后执行的回调函数
                      console.log('分享成功');
                      // Notify({ type: 'success', message: '分享成功' });
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                      console.log('分享取消');
                      // Notify({ type: 'warning', message: '分享取消' });
                  },
                  fail: function (res) {
                    console.log('分享失败'+res);
                  }
                });
              }
              if(id == 'wechat-moments') {
                console.log("分享微信朋友圈");
                wx.updateTimelineShareData({
                  title: that.title, // 分享标题
                  link: currUrl, // 分享链接
                  imgUrl: 'https://www.sjzeis.com/static/img/logo/logo-2.png', // 分享图标
                  desc: desc,
                  success: function () {
                      // 用户确认分享后执行的回调函数
                      console.log('分享成功');
                      // Notify({ type: 'success', message: '分享成功' });
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                      console.log('分享取消');
                      // Notify({ type: 'warning', message: '分享取消' });
                  },
                  fail: function (res) {
                    console.log('分享失败'+res);
                  }
                });
              }

              if(id == 'weibo'){
                console.log("分享微博")
                wx.onMenuShareWeibo({
                  title: that.title, // 分享标题
                  desc: desc, // 分享描述
                  link: currUrl, // 分享链接
                  imgUrl: 'https://www.sjzeis.com/static/img/logo/logo-2.png', // 分享图标
                  success: function () {
                    // 用户确认分享后执行的回调函数
                    console.log('分享成功');
                    // Notify({ type: 'success', message: '分享成功' });
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                    console.log('分享取消');
                    // Notify({ type: 'warning', message: '分享取消' });
                  }
                });
              }


            })

          }
        )

        // 提示对话框
        // Dialog.alert({
        //   message: '根据微信官方声明，分享内容请点击页面右上角“...”菜单进行分享！',
        // }).then(() => {
        //   this.showShare = false
        // });

        // if(id == 'wechat' || id == 'qq') {
        //   wx.updateAppMessageShareData({
        //     title: that.title, // 分享标题
        //     desc: desc, // 分享描述
        //     link: currUrl, // 分享链接
        //     imgUrl: 'https://m.etjkxh.com/wxconfig/logo-share.png', // 分享图标
        //     type: '', // 分享类型,music、video或link，不填默认为link
        //     dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        //     success: function () {
        //         // 用户确认分享后执行的回调函数
        //         console.log('分享成功');
        //         that.showShare = false
        //         Notify({ type: 'success', message: '分享成功' });
        //     },
        //     cancel: function () {
        //         // 用户取消分享后执行的回调函数
        //         console.log('分享取消');
        //         that.showShare = false
        //         Notify({ type: 'warning', message: '分享取消' });
        //     },
        //     fail: function (res) {
        //       that.showShare = false
        //       console.log('分享失败'+res);
        //     }
        //   });
        // }

        // if(id == 'wechat-moments') {
        //   wx.updateTimelineShareData({
        //     title: that.title, // 分享标题
        //     link: currUrl, // 分享链接
        //     imgUrl: 'https://m.etjkxh.com/wxconfig/logo-share.png', // 分享图标
        //     desc: desc,
        //     success: function () {
        //         // 用户确认分享后执行的回调函数
        //         console.log('分享成功');
        //         that.showShare = false
        //         Notify({ type: 'success', message: '分享成功' });
        //     },
        //     cancel: function () {
        //         // 用户取消分享后执行的回调函数
        //         console.log('分享取消');
        //         that.showShare = false
        //         Notify({ type: 'warning', message: '分享取消' });
        //     },
        //     fail: function (res) {
        //       that.showShare = false
        //       console.log('分享失败'+res);
        //     }
        //   });
        // }

        // if(id == 'weibo') {
        //   wx.onMenuShareWeibo({
        //     title: that.title, // 分享标题
        //     desc: desc, // 分享描述
        //     link: currUrl, // 分享链接
        //     imgUrl: 'https://m.etjkxh.com/wxconfig/logo-share.png', // 分享图标
        //     success: function () {
        //       // 用户确认分享后执行的回调函数
        //       console.log('分享成功');
        //       that.showShare = false
        //       Notify({ type: 'success', message: '分享成功' });
        //     },
        //     cancel: function () {
        //       // 用户取消分享后执行的回调函数
        //       console.log('分享取消');
        //       that.showShare = false
        //       Notify({ type: 'warning', message: '分享取消' });
        //     }
        //   });
        // }

      }

      if(id == 'link') {
        this.showShare = false
        let url = window.location.href
        let oInput = document.createElement('input')
        oInput.value = url
        document.body.appendChild(oInput)
        oInput.select()
        document.execCommand("Copy")
        Toast.success('复制成功')

      }

    },

    // encodeUTF8(s) {
    //   var i, r = [], c, x;
    //   for (i = 0; i < s.length; i++)
    //     if ((c = s.charCodeAt(i)) < 0x80) r.push(c);
    //     else if (c < 0x800) r.push(0xC0 + (c >> 6 & 0x1F), 0x80 + (c & 0x3F));
    //     else {
    //       if ((x = c ^ 0xD800) >> 10 == 0) //对四字节UTF-16转换为Unicode
    //         c = (x << 10) + (s.charCodeAt(++i) ^ 0xDC00) + 0x10000,
    //           r.push(0xF0 + (c >> 18 & 0x7), 0x80 + (c >> 12 & 0x3F));
    //       else r.push(0xE0 + (c >> 12 & 0xF));
    //       r.push(0x80 + (c >> 6 & 0x3F), 0x80 + (c & 0x3F));
    //     };
    //   return r;
    // },
    // 字符串加密成 hex 字符串
    // sha1(s) {
    //   var data = new Uint8Array(encodeUTF8(s))
    //   var i, j, t;
    //   var l = ((data.length + 8) >>> 6 << 4) + 16, s = new Uint8Array(l << 2);
    //   s.set(new Uint8Array(data.buffer)), s = new Uint32Array(s.buffer);
    //   for (t = new DataView(s.buffer), i = 0; i < l; i++)s[i] = t.getUint32(i << 2);
    //   s[data.length >> 2] |= 0x80 << (24 - (data.length & 3) * 8);
    //   s[l - 1] = data.length << 3;
    //   var w = [], f = [
    //     function () { return m[1] & m[2] | ~m[1] & m[3]; },
    //     function () { return m[1] ^ m[2] ^ m[3]; },
    //     function () { return m[1] & m[2] | m[1] & m[3] | m[2] & m[3]; },
    //     function () { return m[1] ^ m[2] ^ m[3]; }
    //   ], rol = function (n, c) { return n << c | n >>> (32 - c); },
    //     k = [1518500249, 1859775393, -1894007588, -899497514],
    //     m = [1732584193, -271733879, null, null, -1009589776];
    //   m[2] = ~m[0], m[3] = ~m[1];
    //   for (i = 0; i < s.length; i += 16) {
    //     var o = m.slice(0);
    //     for (j = 0; j < 80; j++)
    //       w[j] = j < 16 ? s[i + j] : rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1),
    //         t = rol(m[0], 5) + f[j / 20 | 0]() + m[4] + w[j] + k[j / 20 | 0] | 0,
    //         m[1] = rol(m[1], 30), m.pop(), m.unshift(t);
    //     for (j = 0; j < 5; j++)m[j] = m[j] + o[j] | 0;
    //   };
    //   t = new DataView(new Uint32Array(m).buffer);
    //   for (var i = 0; i < 5; i++)m[i] = t.getUint32(i << 2);

    //   var hex = Array.prototype.map.call(new Uint8Array(new Uint32Array(m).buffer), function (e) {
    //     return (e < 16 ? "0" : "") + e.toString(16);
    //   }).join("");
    //   return hex;
    // },

    // showMore:function(pId,cId){
    //     // console.log('---------pId:' + pId);
    //     localStorage.setItem('pId', pId);
    //     localStorage.setItem('cId', cId);

    //     // console.log('cId2:---' + localStorage.getItem('cId'));
    //     window.location.href='list.html';
    // },

    copyActiveCode (text) {
      // const clipboard = new Clipboard({ text: () => text })
      // clipboard.on('success', e => {
      //   // this.$message({ type: 'success', message: '复制成功' })
      //   Toast.success('复制成功')
      //   // 释放内存
      //   clipboard.off('error')
      //   clipboard.off('success')
      //   clipboard.destroy()
      // })
      // clipboard.on('error', e => {
      //   // 不支持复制
      //   // this.$message({ type: 'waning', message: '该浏览器不支持自动复制' })
      //   // 释放内存
      //   clipboard.off('error')
      //   clipboard.off('success')
      //   clipboard.destroy()
      // })
      // clipboard.onClick(e)
    },

    getPartTimeForDate: function (val) {
      var timearr = val.replace(' ', ':').replace(/\:/g, '-').split('-')
      var timestr = '' + Number(timearr[1]) + '月' + timearr[2] + '日'
      return timestr
    },
    getPartTimeYmd: function (val) {
      // let ti = val.split(' ');
      var timearr = val.split(' ')
      var timestr = '' + timearr[0]
      return timestr
    }

  }
}
</script>

<style>
.title {
  padding: 0.1rem 1rem;
  font-size: 1.5rem;
  font-weight: bold;
  color: #333333;
  line-height: 2.2rem;
}
.channel {
  padding: 0 1rem;
  color: #333333;
  /* font-weight: bold; */
  font-size: 0.8rem;
}
.time {
  padding: 0.3rem 1rem 0;
  color: gray;
  font-size: 0.5rem;
}
.content {
  padding: 1rem;
}
.content img {
  max-width: 100%;
  max-height: 15rem;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/view/details/details.vue